export default __webpack_public_path__ + "static/media/exhausted.962e3317.svg";